interface PriceWrapper {
	listPrice: number|string;
	sellPrice: number|string;
}

export class ProductBatchItemPriceValuePayloadModel {
	beforeChange: PriceWrapper = {
		listPrice: 0,
		sellPrice: 0,
	};
	new: PriceWrapper = {
		listPrice: 0,
		sellPrice: 0,
	};	
	old: PriceWrapper = {
		listPrice: 0,
		sellPrice: 0,
	};

	constructor(p?: Partial<ProductBatchItemPriceValuePayloadModel>) {
		Object.assign(this, p)

		this._parseNumbers()
	}
	
	updateValuesBeforeChange():void {
		this.beforeChange.listPrice = this.new.listPrice
		this.beforeChange.sellPrice = this.new.sellPrice
	}

	resetValues():void {
		this.new.listPrice = this.beforeChange.listPrice
		this.new.sellPrice = this.beforeChange.sellPrice
	}

	private _parseNumbers():void {
		this.new.listPrice = Number(this.new.listPrice)
		this.new.sellPrice = Number(this.new.sellPrice)
		this.old.listPrice = Number(this.old.listPrice)
		this.old.sellPrice = Number(this.old.sellPrice)
	}
}
